import { apiZodios } from './apiZodios'

const outlookZodios = {
  login: (
    ...args: Parameters<typeof apiZodios.plugins_outlookUserLogin>
  ): ReturnType<typeof apiZodios.plugins_outlookUserLogin> =>
    apiZodios.plugins_outlookUserLogin(...args),
  logout: (
    ...args: Parameters<typeof apiZodios.plugins_outlookUserLogout>
  ): ReturnType<typeof apiZodios.plugins_outlookUserLogout> =>
    apiZodios.plugins_outlookUserLogout(...args),
  getUser: (
    ...args: Parameters<typeof apiZodios.plugins_outlookGetUser>
  ): ReturnType<typeof apiZodios.plugins_outlookGetUser> =>
    apiZodios.plugins_outlookGetUser(...args),
  generateResponse: (
    ...args: Parameters<typeof apiZodios.plugins_outlookGenerateResponse>
  ): ReturnType<typeof apiZodios.plugins_outlookGenerateResponse> =>
    apiZodios.plugins_outlookGenerateResponse(...args),
  listEmails: (
    ...args: Parameters<typeof apiZodios.plugins_outlookListEmails>
  ): ReturnType<typeof apiZodios.plugins_outlookListEmails> =>
    apiZodios.plugins_outlookListEmails(...args),
  getCase: (
    ...args: Parameters<typeof apiZodios.plugins_outlookGetCase>
  ): ReturnType<typeof apiZodios.plugins_outlookGetCase> =>
    apiZodios.plugins_outlookGetCase(...args),
  listTemplates: (
    ...args: Parameters<typeof apiZodios.plugins_outlookListTemplates>
  ): ReturnType<typeof apiZodios.plugins_outlookListTemplates> =>
    apiZodios.plugins_outlookListTemplates(...args),
  listDistinctEmailIdentities: (
    ...args: Parameters<typeof apiZodios.plugins_outlookListDistinctEmailIdentities>
  ): ReturnType<typeof apiZodios.plugins_outlookListDistinctEmailIdentities> =>
    apiZodios.plugins_outlookListDistinctEmailIdentities(...args),
}

export default outlookZodios
